import { TableHeartIcon } from './TableHeartIcon';

/**
 * author: Michael Irigoyen
 * id 550B70E0-414F-44F5-A09F-DF418ABB7D26
 * name table-heart
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/table-heart.svg
 * tags
 */
export const TableFavoriteIcon = TableHeartIcon;
export default TableFavoriteIcon